import {
  IonButton,
  IonButtons,
  IonContent,
  IonFab,
  IonFabButton,
  IonHeader,
  IonIcon,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../util/AppInsights";
import SingleQueryPage from "../components/SingleQueryPage";
import { useCallback, useContext, useEffect, useState } from "react";
import { add, refresh } from "ionicons/icons";
import {
  getApprovalAccess,
  getStoresAccess,
  getUserRequesterAccess,
  getUserTechnicianAccess,
  getMobReqApprovalAccess,
} from "../util/UserHelper";
import { TranslationsContext } from "../util/Translations";
import { AuthContext } from "../util/OAuth";
import { useHistory } from "react-router-dom";
import React from "react";
import StartStopComponent from "../components/StartStopComponent"; // Import the component
import TestEnvBanner from "../components/TestEnvBanner";
import { useOfflineStore } from "../store/offline-mode";
import DownloadedWorkOrders from "../components/DownloadedWorkOrders";
import OfflineTabsHeader, { OfflineTab } from "../components/OfflineTabsHeader";
import DownloadedEquipments from "../components/DownloadedEquipments";
import DownloadedCycleCounts from "../components/DownloadedCycleCounts";

const Home: React.FC = () => {
  const { translations } = useContext(TranslationsContext);
  const [title, setTitle] = useState("");
  const [queryName, setQueryName] = useState("");
  const [fabUrl, setFabUrl] = useState("");
  const { loggedIn } = useContext(AuthContext);
  const history = useHistory();
  const [refreshIsTrue, setRefreshIsTrue] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [showStartStopComponent, setShowStartStopComponent] = useState(false);
  const isOffline = useOfflineStore((state) => state.isOffline);

  const [activeTab, setActiveTab] = useState<OfflineTab>("work");

  const setOptionsByAccess = useCallback(async () => {
    const [techAccess, requesterAccess, storesAccess, approvalAccess, reqApprovalAccess] =
      await Promise.all([
        getUserTechnicianAccess(),
        getUserRequesterAccess(),
        getStoresAccess(),
        getApprovalAccess(),
        getMobReqApprovalAccess(),
      ]);

    if (techAccess) {
      setTitle(
        translations["lbl_my_assigned_wos"] || "My Assigned Work Orders"
      );
      setQueryName("My Assigned Work Orders");
      setFabUrl("/quick-work-order/equipment");
      setRefreshIsTrue(true);
    } else if (requesterAccess) {
      setTitle(translations["lbl_my_recent_wos"] || "My Recent WOs");
      setQueryName("My Recent WOs");
      setFabUrl("/requester/create-request/equipment");
    } else if (storesAccess) {
      history.push("/Stores");
    } else if (approvalAccess) {
      history.push("/WOApproval");
    } else if (reqApprovalAccess) {
      history.push("/RequisitionApproval");
    }

    if (isOffline) {
      if (activeTab === "work") {
        setTitle(
          translations["mob_lbl_my_downloaded_wos"] ||
            "My Downloaded Work Orders"
        );
        setFabUrl("/quick-work-order/true/create");
      } else if (activeTab === "equipment") {
        setTitle(
          translations["mob_lbl_my_downloaded_equip"] ||
            "My Downloaded Equipment"
        );
      } else if (activeTab === "cycleCount") {
        setTitle(
          translations["mob_lbl_my_downloaded_cycle_counts"] ||
            "My Downloaded Cycle Counts"
        );
      }
    }
    //to do: renders empty page if no access - add message
  }, [activeTab, history, isOffline, translations]);

  const refreshSingleQueryPage = () => {
    setRefreshKey((prevKey) => prevKey + 1);
  };

  useEffect(() => {
    setOptionsByAccess();
  }, [queryName, translations, loggedIn, isOffline, setOptionsByAccess]);

  useEffect(() => {
    const storedTimer = localStorage.getItem("StartTime");
    if (storedTimer) {
      setShowStartStopComponent(true);
    }
  }, []);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <>
              <IonMenuButton />
            </>
          </IonButtons>
          <IonTitle>{title}</IonTitle>
          {refreshIsTrue && (
            <IonButton slot="end" onClick={refreshSingleQueryPage}>
              <IonIcon icon={refresh} />
            </IonButton>
          )}
        </IonToolbar>
        <TestEnvBanner />
      </IonHeader>
      <IonContent>
        {showStartStopComponent && <StartStopComponent timeAccess={true} />}
        {!!queryName && !isOffline && (
          <SingleQueryPage key={refreshKey} queryName={queryName} />
        )}
        {isOffline && (
          <>
            <OfflineTabsHeader
              active={activeTab}
              onChange={(val) => setActiveTab(val)}
            />
            {activeTab === "work" && <DownloadedWorkOrders />}
            {activeTab === "equipment" && <DownloadedEquipments />}
            {activeTab === "cycleCount" && <DownloadedCycleCounts />}
          </>
        )}
        {(!!queryName || isOffline) &&
          activeTab !== "equipment" &&
          activeTab !== "cycleCount" && (
          <IonFab slot="fixed" vertical="bottom" horizontal="end">
            <IonFabButton routerLink={fabUrl}>
              <IonIcon icon={add}></IonIcon>
            </IonFabButton>
          </IonFab>
        )}
      </IonContent>
    </IonPage>
  );
};

export default withAITracking(reactPlugin, Home, "Home");
